import { render, staticRenderFns } from "./DesignBaseSwitch.vue?vue&type=template&id=7cdb1966&"
import script from "./DesignBaseSwitch.vue?vue&type=script&lang=js&"
export * from "./DesignBaseSwitch.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports